import React, { useState } from "react"
import { Controller, Control } from "react-hook-form"
import { graphql } from "gatsby"
import Optional from "./form-optional-label"

export const query = graphql`
  fragment FormInputTextarea on DatoCmsFormInputTextarea {
    id
    name
    label
    required
    placeholder
    model {
      apiKey
    }
  }
`

interface FormInputTextarea extends Queries.FormInputTextareaFragment {
  control: Control
}

type FormInputTextareaProps = Omit<FormInputTextarea, "id">

const FormInputTextarea = ({
  name,
  control,
  label,
  required = false,
  placeholder,
}: FormInputTextareaProps) => {
  const [isActive, setIsActive] = useState(false)

  return (
    <Controller
      name={name}
      defaultValue=""
      control={control}
      rules={{ required: required }}
      render={({ field: { onChange, value } }) => (
        <div className={`o-form__item -textarea ${isActive ? "-active" : ""}`}>
          <label
            className={`${
              placeholder ? "c-form__label" : "c-form__label__hovering"
            } -textarea`}
            htmlFor={name}
          >
            {label} {!required && <Optional />}
          </label>
          <textarea
            onBlur={() => setIsActive(value ? true : false)}
            onFocus={() => setIsActive(true)}
            onChange={onChange}
            className={`c-form__text -textarea ${
              placeholder ? "-placeholder" : ""
            }`}
            placeholder={placeholder}
            id={name}
            name={name}
            required={required}
            rows={5}
          ></textarea>
        </div>
      )}
    />
  )
}

export default FormInputTextarea
